import * as React from "react";
import { useHistory } from "react-router-dom";

import { titles } from "../../../constants/titles";
import {
  clearErrorMessage,
  clearSuccessMessage,
  Context,
  createClass,
  CREATE_CLASS_SUCCESS_MESSAGE,
  fetchClasses,
  fetchTeachers,
  IClassParam,
  subClassesPath,
} from "../../../managerStore";
import { Breadcrumb } from "../../../molecules/Breadcrumb";
import SubClassForm from "../../../templates/manager/SubClassForm";
import useWaitApiCall from "../../../hooks/useWaitApiCall";
import useCurrentYear from "../../../hooks/manager/useCurrentYear";

export default () => {
  const { state, dispatch } = React.useContext(Context);
  const [calling, peep] = useWaitApiCall(state);
  const history = useHistory();
  const { currentYear } = useCurrentYear();

  React.useEffect(() => {
    if (state.success_message === CREATE_CLASS_SUCCESS_MESSAGE) {
      dispatch(clearSuccessMessage());
      history.push(subClassesPath);
    }
  }, [history, dispatch, state.success_message]);

  React.useEffect(() => {
    dispatch(fetchTeachers());
    dispatch(fetchClasses(currentYear));
    return () => dispatch(clearErrorMessage());
  }, [currentYear, dispatch]);

  const createSubClassFunc = React.useCallback(
    (cls: IClassParam) => {
      dispatch(peep(createClass(cls)));
    },
    [dispatch, peep],
  );

  return (
    <div>
      <Breadcrumb
        links={[{ title: titles.subClasses, to: subClassesPath }]}
        currentTitle={titles.newSubClass}
      />
      <SubClassForm
        title={titles.newSubClass}
        classes={state.classes}
        calling={calling}
        teachers={state.teachers}
        teacher_ids={[]}
        upsertSubClass={createSubClassFunc}
      />
    </div>
  );
};
